import { render, staticRenderFns } from "./SampleRequest.vue?vue&type=template&id=916007a2&scoped=true&"
import script from "./SampleRequest.vue?vue&type=script&lang=js&"
export * from "./SampleRequest.vue?vue&type=script&lang=js&"
import style0 from "./SampleRequest.vue?vue&type=style&index=0&id=916007a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916007a2",
  null
  
)

export default component.exports